/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createAction, props } from '@ngrx/store';
import { Client, ClientStatusEnum, ICompany, ClientPlan } from '@truckstop-tms/zuum-lib';

export const reset = createAction('[ClientDetails:Dashboard] Reset ClientDetails');

// don't clear existing client while loading
export const reload = createAction('[ClientDetails:Detail] Reload ClientDetails', props<{ clientId: number }>());
export const setClientDetails = createAction(
  '[ClientDetails:Detail] Set ClientDetails Success',
  props<{ client: Client }>()
);

export const load = createAction('[ClientDetails:Detail] Load ClientDetails', props<{ clientId: number }>());
export const loadSuccess = createAction(
  '[ClientDetails:Detail] Load ClientDetails Success',
  props<{ client: Client }>()
);
export const loadFailure = createAction('[ClientDetails:Detail] Load Failure', props<{ errorMessage: string }>());

export const setStripeCustomerId = createAction(
  '[ClientDetails:Guard] Set Stripe Customer Id',
  props<{ id: number; stripeCustomerId: string }>()
);

export const updateClientAutopay = createAction(
  '[ClientDetails:Billing] Update Client Autopay',
  props<{ client: Partial<Client> }>()
);

export const updateClientDetails = createAction(
  '[ClientDetails:Billing] Update Client Details',
  props<{ client: Partial<Client> }>()
);
export const updateClientDetailsSuccess = createAction(
  '[ClientDetails] Update Client Details Success',
  props<{ client: Client }>()
);
export const updateClientDetailsFailure = createAction(
  '[ClientDetails] Update Client Details Failure',
  props<{ errorMessage: string }>()
);

export const updateMongoCompany = createAction('[ClientDetail] Update Mongo Company', props<{ company: ICompany }>());
export const updateMongoCompanySuccess = createAction(
  '[ClientDetails] Update Mongo Company Success',
  props<{ company: ICompany }>()
);

export const updateClientStatus = createAction(
  '[ClientDetails:Dashboard] Update Client Status',
  props<{ client: Client; status: ClientStatusEnum }>()
);

export const updateClientStatusSuccess = createAction(
  '[Client] Update Client Status Success',
  props<{ client: Client }>()
);

export const updateClientStatusFailure = createAction(
  '[Client] Update Client Status Failure',
  props<{ errorMessage: string }>()
);

export const cancelClientPlan = createAction(
  '[ClientDetails:Dashboard/Billing] Cancel Client Plan',
  props<{ cancelationReason: string; client: Client }>()
);

export const cancelClientPlanSuccess = createAction(
  '[ClientDetails:Dashboard/Billing] Cancel Client Plan Success',
  props<{ client: Client }>()
);
export const cancelClientPlanFailure = createAction(
  '[ClientDetails:Dashboard/Billing] Cancel Client Plan Failure',
  props<{ errorMessage: string }>()
);

export const updateClientMaxNumberOfUsers = createAction(
  '[ClientDetails:Users] Update Client Max Number Of Users',
  props<{ id: number; payload: { maxNumberOfUsers: number } }>()
);
export const updateClientMaxNumberOfUsersSuccess = createAction(
  '[ClientDetails:Users] Update Client Max Number Of Users Success',
  props<{ activePlan: ClientPlan }>()
);

export const deleteCompanyDocument = createAction(
  '[ClientDetails:Documents] Delete Company Document',
  props<{ companyId: string; documentType: string }>()
);
export const deleteCompanyDocumentSuccess = createAction(
  '[ClientDetails:Documents] Delete Company Document Success',
  props<{ company: ICompany }>()
);
export const deleteCompanyDocumentFailure = createAction(
  '[ClientDetails:Documents] Delete Company Document Failure',
  props<{ errorMessage: string }>()
);

export const invitationSent = createAction('[ClientDetails:Dashboard] Invitation Sent', props<{ clientId: number }>());
export const invitationSentSuccess = createAction(
  '[ClientDetails:Dashboard] Invitation Sent Success',
  props<{ client: Client }>()
);
export const invitationSentFailure = createAction(
  '[ClientDetails:Dashboard] Invitation Sent Failure',
  props<{ errorMessage: string }>()
);

export const loadBranchesAndAgencies = createAction(
  '[ClientDetails] Load Branches & Agenecies',
  props<{ mongoId: string }>()
);
export const loadBranchesAndAgenciesSuccess = createAction(
  '[ClientDetails] Load Branches & Agenecies Success',
  props<{ clients: Client[] }>()
);
export const loadBranchesAndAgenciesFailure = createAction(
  '[ClientDetails] Load Branches & Agenecies Failure',
  props<{ errorMessage: string }>()
);
